import { Action } from 'redux'
import * as Actions from './actionTypes'
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions'
import { Service } from 'src/common/models/service'
import { ServiceCategory } from 'src/common/models/serviceCategory'

export interface getServicesAction extends Action {
}
export interface getServicesSuccessAction extends Action {
    services: Service[]
}
export const getServicesApi = (): getServicesAction => ({
    type: Actions.GET_SERVICES_API
})
export const getServicesApiSuccess = (services: Service[]): getServicesSuccessAction => ({
    type: Actions.GET_SERVICES_API_SUCCESS,
    services,
})
export const getServicesApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_SERVICES_API_ERROR,
    error,
)

export interface upsertServiceAction extends Action {
    service: Service
}
export interface upsertServiceSuccessAction extends Action {
    service: Service
}
export const upsertServiceApi = (service: Service): upsertServiceAction => ({
    type: Actions.UPSERT_SERVICE_API,
    service,
})
export const upsertServiceApiSuccess = (service: Service): upsertServiceSuccessAction => ({
    type: Actions.UPSERT_SERVICE_API_SUCCESS,
    service,
})
export const upsertServiceApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPSERT_SERVICE_API_ERROR,
    error,
)

export interface getServiceCategoriesAction extends Action {
}
export interface getServiceCategoriesSuccessAction extends Action {
    serviceCategories: ServiceCategory[]
}
export const getServiceCategoriesApi = (): getServiceCategoriesAction => ({
    type: Actions.GET_SERVICE_CATEGORIES_API
})
export const getServiceCategoriesApiSuccess = (serviceCategories: ServiceCategory[]): getServiceCategoriesSuccessAction => ({
    type: Actions.GET_SERVICE_CATEGORIES_API_SUCCESS,
    serviceCategories,
})
export const getServiceCategoriesApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_SERVICE_CATEGORIES_API_ERROR,
    error,
)

export interface UpsertServiceCategoryAction extends Action {
    serviceCategory: ServiceCategory
}
export interface UpsertServiceCategorySuccessAction extends Action {
    serviceCategory: ServiceCategory
}
export const upsertServiceCategoryApi = (serviceCategory: ServiceCategory): UpsertServiceCategoryAction => ({
    type: Actions.UPSERT_SERVICE_CATEGORY_API,
    serviceCategory,
})
export const upsertServiceCategoryApiSuccess = (serviceCategory: ServiceCategory): UpsertServiceCategorySuccessAction => ({
    type: Actions.UPSERT_SERVICE_CATEGORY_API_SUCCESS,
    serviceCategory,
})
export const upsertServiceCategoryApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPSERT_SERVICE_CATEGORY_API_ERROR,
    error,
)

export interface GetServiceByIdAction extends Action {
    serviceId: number
}
export interface GetServiceByIdSuccessAction extends Action {
    service: Service
}
export const getServiceByIdApi = (serviceId: number): GetServiceByIdAction => ({
    type: Actions.GET_SERVICE_BY_ID_API,
    serviceId,
})
export const getServiceByIdApiSuccess = (service: Service): GetServiceByIdSuccessAction => ({
    type: Actions.GET_SERVICE_BY_ID_API_SUCCESS,
    service,
})
export const getServiceByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_SERVICE_BY_ID_API_ERROR,
    error,
)

export const clearCurrentService = () => ({
    type: Actions.CLEAR_CURRENT_SERVICE,
})